import React from 'react';

import './Header.scss';

interface Props {
  title?: string;
  variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

/**
 * @note The component will not be rendered if the title is not present.
 */
const Header = ({ title, variant }: Props): React.ReactElement | null => {
  const HeadingTag = variant;

  if (!title) {
    return null;
  }

  return (
    <div className="header">
      <HeadingTag className="heading">
        <span>
          { title }
        </span>
      </HeadingTag>
    </div>
  );
};

export default Header;
